import { parseNullableValue } from '@hrlogics/helper-utils';

import { useVerifiersBasicListQuery } from 'src/api';
import { useAutocompleteFieldWithQuery } from 'src/hooks/forms';

export const useVerifierAutocomplete = () => {
  return useAutocompleteFieldWithQuery(
    useVerifiersBasicListQuery,
    {
      getQueryItems: data => data?.getVerifiersBasicList,
      queryFilter: searchText => ({ displayName: searchText || undefined }),
    },
    {
      getOptionLabel: option => parseNullableValue(option.displayName),
    },
  );
};
